module.exports = __webpack_public_path__ + "img/seikai.4647d5a5.png";